import { PhoenixLoader } from '../loaders/phoenix-loader';
/**
 * Configuration for preset views and event data loader.
 */
var Configuration = /** @class */ (function () {
    /**
     * Constructor for the Configuration.
     * @param elementId ID of the wrapper element.
     * @param enableDatGUIMenu Whether to enable dat.GUI menu or not.
     */
    function Configuration(elementId, enableDatGUIMenu) {
        if (elementId === void 0) { elementId = 'eventDisplay'; }
        if (enableDatGUIMenu === void 0) { enableDatGUIMenu = false; }
        this.elementId = elementId;
        this.presetViews = [];
        this.eventDataLoader = new PhoenixLoader();
        this.enableDatGUIMenu = enableDatGUIMenu;
    }
    /**
     * Get if there are any preset views.
     * @returns If there are any preset views.
     */
    Configuration.prototype.anyPresetView = function () {
        return this.presetViews.length > 0;
    };
    /**
     * Set the event data loader to be used.
     * @param eventDataLoader Event data loader responsible for
     * processing and loading event data.
     */
    Configuration.prototype.setEventDataLoader = function (eventDataLoader) {
        this.eventDataLoader = eventDataLoader;
    };
    /**
     * Get the event data loader responsible for processing and loading event data.
     * @returns The event data loader.
     */
    Configuration.prototype.getEventDataLoader = function () {
        return this.eventDataLoader;
    };
    /**
     * Set he root node for phoenix menu.
     * @param phoenixMenuNode The phoenix menu node to be set as the root node.
     */
    Configuration.prototype.setPhoenixMenuRoot = function (phoenixMenuNode) {
        this.phoenixMenuRoot = phoenixMenuNode;
    };
    /**
     * Get he root node for phoenix menu.
     * @return The root node of phoenix menu.
     */
    Configuration.prototype.getPhoenixMenuRoot = function () {
        return this.phoenixMenuRoot;
    };
    return Configuration;
}());
export { Configuration };
//# sourceMappingURL=configuration.model.js.map